import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { ReserveModel, ReserveTypeModel } from './reserve.model';
import { ReserveService } from './reserve.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { DummyComponent } from '../../../../shared/dummy.component';
import { ReserveListComponent } from './reserve-list.component';
import { AccountMovementsViewModel } from '../../../accounting/models/accounting-movement.model';
import { SharedService } from '../../../../shared/services/shared.service';

@Component({
    selector: 'app-reserve-form',
    templateUrl: './reserve-form.component.html',
    styleUrls: ['./reserve-form.component.css'],
    standalone: false
})
export class ReserveFormComponent implements OnInit {

  uid: number = this.data.uid;

  //AccountMovementes Import data
  flagImport: boolean = this.data.flagImport;
  movement: AccountMovementsViewModel;
  type: string;
  saved: boolean = false;
  //------------------------------
  ready: boolean = false;
  amountFormControl: UntypedFormControl;
  reserveTypeFormControl: UntypedFormControl;
  reserveModel: ReserveModel;
  reserveTypeModel: ReserveTypeModel[] = [];
  submitted: boolean = false;

  constructor(
    public ReserveService: ReserveService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dummy: DummyComponent,
    public dialogRef: MatDialogRef<ReserveListComponent>,
    public snackBar: MatSnackBar,
    private sharedService: SharedService
  ) {
    this.reserveModel = new ReserveModel();
    this.amountFormControl = new UntypedFormControl();
    this.reserveTypeFormControl = new UntypedFormControl();
  }

  ngOnInit() {
    if (this.data.movement !== undefined) {
      this.movement = this.data.movement;
      this.type = this.data.type;
      this.movement.type = this.type;
      this.reserveModel.amount = this.movement.amount * -1;
      this.reserveModel.manualMovement = this.movement;

      this.sharedService.checkIfAccountNumberExists(this.movement.accountNumber, this.movement.type).then(response => {
        this.reserveModel.accountingModelsNumber = response;
        this.reserveModel.manualMovement.accountNumber = response;
      })
    }
    this.reserveModel.uid = this.uid;

    this.ReserveService.getListType().then(
      dataType => {
        this.reserveTypeModel = dataType;
      });

    if (this.uid != undefined && this.uid !== null) {
      this.ready = false;

      this.ReserveService.loadData(this.uid).then(reserve => {
        this.reserveModel = reserve;
        this.amountFormControl.setValue(reserve.amount ?? null);

        const matchingType = this.reserveTypeModel.find(type => type.id === this.reserveModel.reserveTypeId);
        if (matchingType) {
          this.reserveModel.reserveTypeName = matchingType.name;
        }

        this.ready = true;
      });

    } else {
      this.ready = true;
    }
  }

  // SAVE
  onSubmit() {
    if (this.amountFormControl.invalid && this.reserveTypeFormControl.invalid) {
      this.amountFormControl.markAsTouched();
      this.reserveTypeFormControl.markAsTouched();
    }

    if (this.isDataValid()) {
      this.submitted = true;
      this.reserveModel.amount = this.amountFormControl.value;
      this.save(this.reserveModel);
    } else {
      this.displayInfo("Compruebe los campos marcados en rojo");
      return;
    }
  }

  private isDataValid(): boolean {
    if (!this.amountFormControl.invalid && !this.reserveTypeFormControl.invalid) {
      return true;
    }
    return false;
  }

  save(reserveModel) {
    const noError = true;
    const mensajeError = '';
    if (noError) {
      if (reserveModel.uid == null) {
        this.ReserveService.addData(reserveModel)
          .then(reserveModel => {
            this.reserveModel = reserveModel;
            if (this.data != null) {
              this.saved = true;
              this.closeDialog();
            } else {
              this.dummy.redirectTo('/partnersequity/reserve');
            }
          },
            error => this.displayInfo(error.error['message'])
          )
      } else {
        this.ReserveService.editData(reserveModel.uid, reserveModel)
          .then(reserveModel => {
            this.reserveModel = reserveModel;
            this.dummy.redirectTo('/partnersequity/reserve');
          },
            error => this.displayInfo(error.error['message'])
          )
      }
    } else {
      this.displayInfo(mensajeError);
    }
  }

  displayInfo(message: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10000;
    options.panelClass = ['custom-snackbar', 'custom-snackbar-container']; this.snackBar.open(message, '', options);
  }

  closeDialog() {
    this.dialogRef.close(this.saved);
  }
}
